import React from 'react';

export interface ICarouselItemProps {
	children: any;
}

/**
 * Carousel Item
 * @block
 */
const CarouselItem: React.FC<ICarouselItemProps> = ({ children }) => (
	<li className="glide__slide">{children}</li>
);

export default CarouselItem;
